<template>
    <loading v-if="loading" :message="message"/>
    <login v-else/>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";

import Login from "@/components/login/Login.vue";
import Loading from "@utils/Loading.vue";
import { useErrorStore } from "@/stores/errorStore";
import { usePaymentStore } from "@/stores/paymentStore";

@Component({ components: { Loading, Login }})
export default class VendiblePaymentConfirmed extends Vue
{
    loading: boolean = false;

    get vendibleId()
    {
        return this.$route.params.vendibleid;
    }

    get message(): string
    {
        return usePaymentStore().processingPaymentMessage || this.$t('VENDIBLE_PAYMENT_PROCESSING_MESSAGE');
    }

    async created()
    {
        this.loading = true
        try
        {
            await usePaymentStore().processPaymentConfirmed(this.vendibleId);
        }
        catch(e)
        {
            if (e instanceof Error && e.name === 'NoPaymentSessionDataFoundError')
            {
                useErrorStore().setError(new Error(this.$t('VENDIBLE_CONFIRMED_NO_DATA').toString()))
            }

            // Only set loading to false if there is an error so the loading message shows while redirecting
            this.loading = false
        }
    }
}
</script>
